import PropTypes from "prop-types";
import { forwardRef } from "react";
// @mui
import { MenuItem } from "@mui/material";
//
import { DROPDOWN } from "src/config-global";

// ----------------------------------------------------------------------

const XMenuItem = forwardRef(({ children, value, sx, ...other }, ref) => (
    <MenuItem ref={ref} value={value} {...other}
              sx={{
                  "&.MuiMenuItem-root:not(:last-of-type)": {
                      marginTop: 0,
                      marginBottom: `${DROPDOWN.SPACING}px`
                  },
                  "&.MuiMenuItem-root(:last-of-type)": {
                      marginBottom: 0
                  },
                  minHeight: "auto",
                  py: `${DROPDOWN.PADDING_Y}px`,
                  px: `${DROPDOWN.PADDING_X}px`,
                  borderRadius: `${DROPDOWN.BASE_RADIUS}px`,
                  ...sx
              }}
    >
        {children}
    </MenuItem>
));

XMenuItem.propTypes = {
    children: PropTypes.node,
    sx: PropTypes.object,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.object])
};

export default XMenuItem;
